import { useQuery } from "react-query";
import api from "../api";

export const useGetWithdrawRequestForAdmin = (status) => {
  return useQuery(["withdraw_request", status], () => {
    const url = status === "ALL" ? "/withdraw/list" : `/withdraw/list?status=${status}`;
    return api.get(url).then((res) => res.data);
  });
};
